import { EventProxy } from './eventProxy';
import { generatePluginEventListenerCallbackParams } from './actionParams';
var hotAreaEventListeners = new EventProxy();
export function onHotArea(eventType, callback) {
    hotAreaEventListeners.on(eventType, callback);
}
export function emitHotArea(e, eventType, hotArea, component, meta, global) {
    var params = generatePluginEventListenerCallbackParams(eventType, global, meta, component, hotArea);
    if (e) {
        params.originalEvent = e;
    }
    hotAreaEventListeners.emit(eventType, params);
}
//# sourceMappingURL=hotAreaEventListener.js.map